export const WHITE_LIST = [
    { name: 'notFound', children: [] },
    { name: 'forbidden', children: [] },
    { name: 'login', children: [] },
    { name: 'device-detail', children: [] },
    { name: 'big-screen-station', children: [] },
];

export const NOT_FOUND = {
    name: 'notFound',
};
export const FORBIDDEN = {
    name: 'forbidden',
};

export const REDIRECT_ROUTE_NAME = 'Redirect';

export const DEFAULT_ROUTE_NAME = 'Workplace';

export const DEFAULT_ROUTE = {
    title: 'menu.dashboard.workplace',
    name: DEFAULT_ROUTE_NAME,
    fullPath: '/dashboard/workplace',
};

export const DEFAULT_HOME = {
    name: 'menus-management',
    query: {},
};
